import { Button } from "@/components/ui/button";
import { MoreVertical } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DeleteLeadDialog } from "./DeleteLeadDialog";

interface LeadActionsMenuProps {
  onEdit: (e: React.MouseEvent) => void;
  onDelete: () => void;
}

export const LeadActionsMenu = ({ onEdit, onDelete }: LeadActionsMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={(e) => {
            e.stopPropagation();
            onEdit(e);
          }}
        >
          Edit Lead
        </DropdownMenuItem>
        <DeleteLeadDialog onDelete={onDelete} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};